const config = {
    base_url: process.env.VUE_APP_BASE_URL
}
const storage = config.base_url+'/storage/';
const stor = config.base_url+'/stor/';
const stripe_key = process.env.VUE_APP_STRIPE_KEY;
export default {
    storage, config, stor, stripe_key
};
